<script setup lang="ts">
const year = new Date().getFullYear()
const disconnect = ref(false)
const { loggedIn, clear } = useUserSession()

async function clearSession() {
  disconnect.value = true
  await clear().finally(() => {
    disconnect.value = false
  })
}
</script>

<template>
  <footer class="w-full relative z-20 h-9 shrink-0 border-t border-white/30 bg-black/35 backdrop-blur-sm">
    <div class="h-full max-w-6xl mx-auto px-6 md:px-10 flex items-center justify-between gap-3 text-[11px] text-gray-400">
      <span>© {{ year }} Florian Cech</span>
      <UButton
        v-if="loggedIn"
        :loading="disconnect"
        icon="i-heroicons-power-20-solid"
        variant="solid"
        size="xs"
        label="Logout"
        class="rounded-full shadow-lg"
        aria-label="Logout"
        @click="clearSession"
      />
      <NuxtLink
        to="/imprint"
        class="hover:text-white transition-colors"
      >
        Imprint
      </NuxtLink>
    </div>
  </footer>
</template>
